
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/legal/specified-commercial-transactions",
      function () {
        return require("private-next-pages/[lng]/legal/specified-commercial-transactions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/legal/specified-commercial-transactions"])
      });
    }
  